import React from "react";
import styles from "./DealerDeliveryRanges.module.scss";
import MultiToggleWidget from "../../../../shared/toggles/multiToggleWidget/MultiToggleWidget";

const OptionToggle = (props) => {
  const isDisabled =
    props.disabled ||
    props.user.readOnly ||
    !props.user.permissions.rolePermissions.hasOwnProperty(
      "deliveryRanges:write"
    );

  return (
    <div
      id={props.id}
      className={`${styles.subSectionBackGround} pagePaddingLeft pagePaddingRight`}
    >
      <div>
        <p className={styles.taskHeader}>{props.header}</p>
        <p className={styles.taskDetails}>{props.body}</p>
      </div>

      <div>
        <MultiToggleWidget
          settings={{
            acceptedText: props.t("GeneralEMP.statusYes"),
            rejectedText: props.t("GeneralEMP.statusNo"),
            suppClass: `${isDisabled ? "" : styles.toggleWrapper}`,
          }}
          isToggleDisabled={isDisabled}
          toggleName={props.toggleName}
          currentStatus={props.data ? "yes" : "no"}
          onSelect={(e) => props.action(e)}
        />
      </div>
    </div>
  );
};

export default OptionToggle;
